var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMatter1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.89474 21C3.37895 21 3 19 3 18V13.0477C3.45318 14.3583 4.6455 14.9063 7 15H17C19.357 14.7752 20.532 14.1705 21 13.0078V18C21 20 19.7368 20.8334 19.1053 21H4.89474Z",
    fill: "#00685F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 6.75H17.55C16.65 4.5 14.475 3 12 3C9.525 3 7.35 4.5 6.45 6.75H4.5C3.225 6.75 2.25 7.725 2.25 9V9.45C2.25 12.075 4.425 14.25 7.05 14.25H17.025C19.65 14.25 21.825 12.075 21.825 9.45V9C21.75 7.725 20.775 6.75 19.5 6.75ZM12 4.5C13.65 4.5 15.075 5.4 15.9 6.75H8.1C8.925 5.4 10.35 4.5 12 4.5Z",
    fill: "#00685F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatter1);
export default __webpack_public_path__ + "static/media/Matter 1.e6bfa6b118e9b0d2e66b0416b147bb6d.svg";
export { ForwardRef as ReactComponent };